import actions from '@/store/modules/price/actions/index'

const initialState = () => ({
    price: 500,
    restPrice: {},
    priceDuration: {
        value: 0
    },
    priceThem: {
        value: 0,
        coef: 0
    },
    priceVideo: {
        value: 0,
        coef: 0
    },
    priceMusic: {
        value: 0,
        coef: 0
    },
    priceDate: {
        type: 'default',
        value: 0
    },
    pricePrimeTime: {
        value: 1,
        coef: 1
    },
    duration: 230,
    video: 0
})

const mutations = {
    setMusic(state, { music }) {
        state.music = music
    },
    setDuration(state, { duration }) {
        state.duration = duration
    },
    setVideo(state, { video }) {
        state.video = video
    },
    setPrice(state, { price }) {
        state.price = price
    },
    setPriceVideo(state, { value, coef }) {
        state.priceVideo.value = value
        state.priceVideo.coef = coef
        state.price = Math.trunc(value)
    },
    setPriceDuration(state, { value }) {
        state.priceDuration.value = value
        state.price = Math.trunc(value)
    },
    setPriceThem(state, { value, coef }) {
        let check_coef = coef ? coef : 1
        let check_value = value ? value : 1
        state.priceThem.value =  Math.trunc(check_value * state.price)
        state.priceThem.coef = check_coef
        state.price =  Math.trunc(check_value * state.price)
    },
    setPriceMusic(state, { value, coef}) {
        let check_coef = coef ? coef : 1
        let check_value = value ? value : 1
        state.priceMusic.value = Math.trunc(check_value * state.price)
        state.priceMusic.coef = check_coef
        state.price = Math.trunc(check_value * state.price)
    },
    setDatePrice(state, { value, type }) {
        state.priceDate.value =  Math.trunc(value * state.price)
        state.priceDate.type = type
        state.price = Math.trunc(value * state.price)
    },
    setPricePrimeTime(state, { value, coef }) {
        let check_coef = coef ? coef : 1
        let check_value = value ? value : 1
        state.pricePrimeTime.value =  Math.trunc(check_value * state.price)
        state.pricePrimeTime.coef = check_coef
        state.price = Math.trunc(check_value * state.price)
    },
    restPrice(state, { data }) {
        state.restPrice = data
    },
    resetState(state) {
        const initial = initialState()
        Object.keys(initial).forEach(key => { state[key] = initial[key] })
    }
}

const getters = {
    price: state => state.price,
    duration: state => state.duration,
    video: state => state.video,
    priceDuration: state => state.priceDuration,
    priceThem: state => state.priceThem,
    priceVideo: state => state.priceVideo,
    priceMusic: state => state.priceMusic,
    priceDate: state => state.priceDate,
    pricePrimeTime: state => state.pricePrimeTime,
    priceSurvey: state => state.priceSurvey,
    restPrice: state => state.restPrice
}

export default {
    namespaced: true,
    state: initialState,
    getters,
    mutations,
    actions
};
